import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaypal2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	"aria-label": "paypalIcon",
	width: 18,
	height: 20,
	viewBox: "0 0 18 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9671 1.55243C14.0975 0.558551 12.4824 0.061615 10.2462 0.061615H4.0345C3.6618 0.061615 3.2891 0.434316 3.16486 0.80702L0.680176 17.0817C0.680176 17.4544 0.928645 17.7029 1.17711 17.7029H5.02838L6.02226 11.6154V11.8639C6.14649 11.4912 6.51919 11.1185 6.8919 11.1185H8.75541C12.3582 11.1185 15.0914 9.62767 15.961 5.52793C15.961 5.40369 15.961 5.27946 15.961 5.15522C15.8368 5.15522 15.8368 5.15522 15.961 5.15522C16.0852 3.54018 15.8368 2.5463 14.9671 1.55243Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8369 5.1545C15.8369 5.27873 15.8369 5.40297 15.8369 5.5272C14.9672 9.75117 12.2341 11.1177 8.63126 11.1177H6.76775C6.39504 11.1177 6.02234 11.4905 5.89811 11.8632L4.65576 19.4414C4.65576 19.6899 4.78 19.9384 5.1527 19.9384H8.38279C8.7555 19.9384 9.1282 19.6899 9.1282 19.3172V19.193L9.74937 15.3417V15.0932C9.74937 14.7205 10.1221 14.4721 10.4948 14.4721H10.9917C14.0976 14.4721 16.5823 13.2297 17.2034 9.5027C17.4519 8.01189 17.3277 6.64531 16.5823 5.77567C16.458 5.5272 16.2096 5.27873 15.8369 5.1545Z",
			fill: "white",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.9669 4.78304C14.8426 4.78304 14.7184 4.65881 14.5941 4.65881C14.4699 4.65881 14.3457 4.65881 14.2214 4.53457C13.7245 4.41034 13.2276 4.41034 12.6064 4.41034H7.76125C7.63702 4.41034 7.51279 4.41034 7.38855 4.53457C7.14008 4.65881 7.01585 4.90728 7.01585 5.15574L6.02197 11.6159V11.8644C6.14621 11.4917 6.51891 11.119 6.89161 11.119H8.75513C12.3579 11.119 15.0911 9.62818 15.9607 5.52845C15.9607 5.40421 15.9607 5.27998 16.085 5.15574C15.8365 5.03151 15.7123 4.90728 15.4638 4.90728C15.0911 4.78304 15.0911 4.78304 14.9669 4.78304Z",
			fill: "#E4F2F8"
		})
	]
});
export default SvgPaypal2;
